import { render, staticRenderFns } from "./DealDropdownField.vue?vue&type=template&id=20aec037"
import script from "./DealDropdownField.vue?vue&type=script&lang=ts"
export * from "./DealDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20aec037')) {
      api.createRecord('20aec037', component.options)
    } else {
      api.reload('20aec037', component.options)
    }
    module.hot.accept("./DealDropdownField.vue?vue&type=template&id=20aec037", function () {
      api.rerender('20aec037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/DealDropdownField.vue"
export default component.exports